import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { PageTitle, Link } from '../../../components';
import { CodeBlock } from '../code-block';
import { handleCopyClick } from '../constants';
import { StyleGuidePage } from '../style-guide-page';

export const StyleGuidePageTitle = () => {
  const [isCopied, setIsCopied] = useState<{
    [val: string]: boolean;
  }>({});

  return (
    <StyleGuidePage title="Page Title">
      <Grid container mb={2}>
        <Grid item xs={12} lg={8}>
          <Typography mb={1}>
            The page title component was built to render the page title of the page (h1) with
            various different configurations, including subTitle.
          </Typography>
          <Typography mb={1}>
            This component is used for top level pages or pages that are standalone and not
            connected to other pages. For all other pages, the{' '}
            <Link to="/kitchen-sink/components/page-title-with-back">Page Title with Back</Link>{' '}
            should be used.
          </Typography>
          <code>
            Props:
            <br />- title: string
            <br />- showDivider?: boolean
            <br />- additionalHeaderContent?: JSX.Element
            <br />- subTitle?: string
            <br />- marginBottom?: boolean
            <br />- additionalHeaderContentClass?: string
          </code>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box mb={1}>
            <PageTitle
              title="Custom Page Title"
              subTitle="This is an example of the page title component and its common props"
            />
          </Box>
          <CodeBlock handleCopyClick={e => handleCopyClick(setIsCopied, e)} isCopied={isCopied}>
            &lt;PageTitle title="Custom Page Title" /&gt;
          </CodeBlock>
        </Grid>
      </Grid>
    </StyleGuidePage>
  );
};
